import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem from "@insite/mobius/GridItem";
import getColor from "@insite/mobius/utilities/getColor";
import StoreHideAllPricesModeToggle from "@store/Components/Store/StoreHideAllPricesModeToggle";
import StoreRetailModeToggle from "@store/Components/Store/StoreRetailModeToggle";
import { getRetailModeActive } from "@store/Store/Data/RetailMode/RetailModeSelector";
import StoreApplicationState from "@store/Store/StoreApplicationState";
import React from 'react';
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: StoreApplicationState) => {
    return {
        isRetailModeActive: getRetailModeActive(state)
    };
};

const toggleStyles = {
    wrapper: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: flex-start; 
        `,
    },
    gridContainer: {
        css: css`
            width: 100%;
            padding: .5em;
            margin-bottom: .5em;
            padding-left: 0;
            border-bottom: 1px solid ${getColor("common.border")};
        `
    },
};

const LoginButtonCheckboxDisplay: React.FC<{}> = (isRetailModeActive) => {
    return (
        <StyledWrapper {...toggleStyles.wrapper}>
            <GridContainer {...toggleStyles.gridContainer}>
                <GridItem width={6}>
                    {isRetailModeActive && (
                        <StoreRetailModeToggle />
                    )}
                </GridItem>
                <GridItem width={6}>
                    <StoreHideAllPricesModeToggle />
                </GridItem>
            </GridContainer>
        </StyledWrapper>
    );
};

export default connect(mapStateToProps)(LoginButtonCheckboxDisplay);
